import { render } from "./UsedBy.vue?vue&type=template&id=4c994d3d"
import script from "./UsedBy.vue?vue&type=script&lang=ts"
export * from "./UsedBy.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./UsedBy.vue?vue&type=style&index=0&id=4c994d3d&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script